// import * as types from './actionTypes';
import { LOCATION_CHANGE } from 'connected-react-router';
import { fromJS } from 'immutable';
import * as types from './actionTypes';
import initialState from '../../Store/initialState';

import { locale } from '../Tools/reducers';
import { getPathName } from '../../Utils/Utils';

let newState;
let redirectTo;

const system = (state = initialState.get('system'), action) => {
  try {
    switch (action.type) {
      case LOCATION_CHANGE: {
        redirectTo = getPathName(action.payload.location) || '';
        newState = state.set('redirectTo', redirectTo.includes('login') ? '/' : redirectTo);
        return newState;
      }

      case types.FETCH_USER_LANGUAGE:
        const i18n = { lang: action?.data?.language };

        if (action?.data?.locale?.thousands_sep) {
          i18n.thousandSeparator = action?.data?.locale?.thousands_sep;
        }
        if (action?.data?.locale?.decimal_point) {
          i18n.decimalSeparator = action?.data?.locale?.decimal_point;
        }

        newState = state.mergeDeep(state, fromJS({ i18n }));
        newState = newState.set('menuStrings', locale(action?.data?.language, 'menu'));
        newState = newState.set(
          'navItems',
          fromJS(
            newState
              .get('navItems')
              .toJS()
              .map(nav => ({ ...nav, label: locale(action?.data?.language, nav.to.slice(1))?.menu ?? nav.label }))
          )
        );
        return newState;

      // UPDATE_MENUDRAWER_SETTINGS
      case types.UPDATE_MENUDRAWER_SETTINGS:
        newState = state.mergeDeep(state, fromJS({ menuDrawerSettings: action.settings }));
        return newState;

      // TOGGLE_ABOUT
      case types.TOGGLE_ABOUT:
        newState = state.mergeDeep(state, fromJS({ showAbout: !action.toggle }));
        return newState;

      // FETCH FREQUENCY
      case types.FETCH_FREQUENCY_REQUEST: {
        newState = state.setIn(['loading', 'isFrequencyStatus'], true);
        return newState;
      }

      case types.FETCH_FREQUENCY_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            frequency: action.data.desc,
          })
        );
        newState = newState.setIn(['loading', 'isFrequencyStatus'], false);
        return newState;
      }

      case types.FETCH_FREQUENCY_FAIL: {
        newState = state.mergeDeep(
          state,
          fromJS({
            frequency: [],
          })
        );
        newState = newState.setIn(['loading', 'isFrequencyStatus'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS(action.error));
        return newState;
      }

      // FETCH CLAUSES
      case types.FETCH_CLAUSES_REQUEST: {
        newState = state.setIn(['loading', 'isClausesStatus'], true);
        return newState;
      }

      case types.FETCH_CLAUSES_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            clauses: action.data,
          })
        );
        newState = newState.setIn(['loading', 'isClausesStatus'], false);
        return newState;
      }

      case types.FETCH_CLAUSES_FAIL: {
        newState = state.mergeDeep(
          state,
          fromJS({
            clauses: [],
          })
        );
        newState = newState.setIn(['loading', 'isClausesStatus'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS(action.error));
        return newState;
      }

      // FETCH ICONS
      case types.FETCH_ICONS_REQUEST: {
        newState = state.setIn(['loading', 'isIconsStatus'], true);
        return newState;
      }

      case types.FETCH_ICONS_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            icons: action.data,
          })
        );
        newState = newState.setIn(['loading', 'isIconsStatus'], false);
        return newState;
      }

      case types.FETCH_ICONS_FAIL: {
        newState = state.mergeDeep(
          state,
          fromJS({
            icons: [],
          })
        );
        newState = newState.setIn(['loading', 'isIconsStatus'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS(action.error));
        return newState;
      }

      // SERVICES INFO
      case types.FETCH_SERVICEINFO_SUCCESS:
        newState = state.set(
          'serviceInfo',
          fromJS([
            ...(process.env.REACT_APP_VERSION ? [{ name: 'Coog Portal', version: process.env.REACT_APP_VERSION }] : []),
            ...action.data,
          ])
        );
        return newState;

      case types.FETCH_SERVICEINFO_FAIL:
        newState = newState.setIn(['alerts', 'errors'], fromJS(action.error));
        return newState;

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default system;
